import { httpsCallable } from "firebase/functions";
import { isBooleanTrue, isListNotEmpty, isObjectNotEmpty, isStringNotEmpty } from "../utils/objectUtils";
import { functions } from ".";
import CONSTANTS from "../constants";
import Activity from "../models/Activity";

export const sendFCMMessage = async (message) => {
    try {
        if (isObjectNotEmpty(message)) {
            const func = httpsCallable(functions, "sendmessage", { timeout: 6000000 });
            const res = await func({ message });

            console.log(res?.data);
            return res?.data;
        }
    } catch (error) {
        console.log(error);
    }

    return null;
};

export const sendFCMMessages = async (messages) => {
    try {
        if (isListNotEmpty(messages)) {
            const func = httpsCallable(functions, "sendmessages", { timeout: 6000000 });
            const res = await func({ messages });

            console.log(res?.data);
            return res?.data;
        }
    } catch (error) {
        console.log(error);
    }

    return null;
};


export const sendFCMMessageToTopic = async (topic, messagingPayload, messagingOptions = {}) => {
    try {
        const func = httpsCallable(functions, "sendmessagetotopic", { timeout: 6000000 });
        const res = await func({ topic, messagingPayload, messagingOptions });

        console.log(res?.data);
        return res?.data;
    } catch (error) {
        console.log(error);
    }

    return null;
};

export const sendFCMMessageToCondition = async (condition, messagingPayload, messagingOptions = {}) => {
    try {
        if (isStringNotEmpty(condition) && isObjectNotEmpty(messagingPayload)) {
            const func = httpsCallable(functions, "sendmessagetocondition", { timeout: 6000000 });
            const res = await func({ condition, messagingPayload, messagingOptions });

            console.log(res?.data);
            return res?.data;
        }
    } catch (error) {
        console.log(error);
    }

    return null;
};

export const subscribeToFCMTopic = async (deviceToken, topic) => {
    try {
        if (isStringNotEmpty(deviceToken) && isStringNotEmpty(topic)) {
            const func = httpsCallable(functions, "subscribetotopic", { timeout: 6000000 });
            const res = await func({ deviceToken, topic });

            console.log('subscribeToFCMTopic', res?.data);
            return res?.data;
        }
    } catch (error) {
        console.log(error);
    }

    return null;
};

export const unsubscribeFromFCMTopic = async (deviceToken, topic) => {
    try {
        if (isStringNotEmpty(deviceToken) && isStringNotEmpty(topic)) {
            const func = httpsCallable(functions, "unsubscribefromtopic", { timeout: 6000000 });
            const res = await func({ deviceToken, topic });

            console.log('unsubscribeFromFCMTopic', res?.data);
            return res?.data;
        }
    } catch (error) {
        console.log(error);
    }

    return null;
};